import React from "react";

import { Card } from "primereact/card";
import { TabPanel, TabView } from "primereact/tabview";
import { T } from "services/lang/LanguageService";
import AlertsManagement from "./AlertsManagement";

const CompanyConfigurationPage: React.FC = () => {
  return (
    <Card title={T("word.configuration")}>
      <TabView>
        <TabPanel header={T("word.alerts-management")}>
          <AlertsManagement />
        </TabPanel>
      </TabView>
    </Card>
  );
};

export default CompanyConfigurationPage;
